import React from 'react';
import './Offers.css';
import OfferG from '../Assets/OfferG.png';
import { Link } from 'react-router-dom';

const Offers = () => {
  return (
    <div className="offers-container">
      <div className="offers-content">
        <div className="offers-text">
          <h1 className="offers-title">
            EXCLUSIVE <span className="highlight">Offers For You!</span>
          </h1>
          <p className="offers-subtitle">ONLY ON GOATS</p>
          <Link to="/goats" className="offers-button">
            Shop Now
            <svg xmlns="http://www.w3.org/2000/svg" className="button-icon" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </Link>
        </div>
        <div className="offers-image">
          <Link to="/goats">
            <img src={OfferG} alt="Exclusive offers" className="offer-img" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Offers;